module.exports = __webpack_public_path__ + "static/media/SuccessMessage.ec6e59f4.svg";